export default __webpack_public_path__ + "static/media/keyDown.0c9b85cd.svg";